// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__20AxC","containerItemsCenter":"Skeleton_containerItemsCenter__OiLfe"};